
export const isValidUrlFormat = (url) => {
  if (!url || typeof url !== 'string') {
    return false;
  }
  
  try {
    const urlObj = new URL(url);
    return urlObj.protocol === 'http:' || urlObj.protocol === 'https:';
  } catch (error) {
    return false;
  }
};

export const filterValidUrlFormats = (urls) => {
  if (!Array.isArray(urls)) {
    return [];
  }
  
  return urls.filter(url => isValidUrlFormat(url));
}; 